/* istanbul ignore file */

// PLACEHOLDER: awaiting Design wording. Not "guaranteed", which only the toggle may say.
export const getGuaranteedArrivalChipTitle = (dayName: string) => `${dayName} delivery`;
